import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Statistic, Table, Typography } from 'antd'
import { EnvironmentOutlined, FileTextOutlined, UserOutlined } from '@ant-design/icons'
import { Helmet } from 'react-helmet-async'
import adminService from '../../services/adminService'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

type ResearchData = {
  key: string;
  id: number;
  title: string;
  user: string;
  service: string;
  createdAt: string;
}

const AdminIndexPage: React.FC = () => {
  const [loading, setLoading] = useState(true)
  const [usersCount, setUsersCount] = useState(0)
  const [researchesCount, setResearchesCount] = useState(0)
  const [objsCount, setObjsCount] = useState(0)
  const [recentResearches, setRecentResearches] = useState<ResearchData[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    Promise.all([
      adminService.userList(),
      adminService.allResearches(),
      adminService.objsCount()
    ]).then(([users, researches, objs]) => {
      setUsersCount(users.users.length)
      setResearchesCount(researches.data.length)
      setObjsCount(objs.count)

      const sorted = [...researches.data]
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .slice(0, 5)
        .map(r => ({
          key: r.id.toString(),
          id: r.id,
          title: r.title,
          user: r.user ? `${r.user.firstName} ${r.user.lastName}` : '',
          service: r.service?.name ?? '',
          createdAt: r.createdAt
        }))
      setRecentResearches(sorted)
      setLoading(false)
    })
  }, [])

  const columns = [
    {
      title: 'Название',
      dataIndex: 'title',
      key: 'title',
      render: (title: string, record: ResearchData) => (
        <a onClick={() => navigate('/researches/' + record.id)}>{title}</a>
      )
    },
    {
      title: 'Автор',
      dataIndex: 'user',
      key: 'user'
    },
    {
      title: 'Сервис',
      dataIndex: 'service',
      key: 'service'
    },
    {
      title: 'Дата',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date: string) => dayjs(date).format('DD/MM/YYYY')
    }
  ]

  return (
    <div>
      <Helmet><title>Prisma — Панель управления</title></Helmet>
      <Typography.Title level={3}>Панель управления</Typography.Title>
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={8}>
          <Card loading={loading}>
            <Statistic title="Пользователи" value={usersCount} prefix={<UserOutlined/>}/>
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card loading={loading}>
            <Statistic title="Исследования" value={researchesCount} prefix={<FileTextOutlined/>}/>
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card loading={loading}>
            <Statistic title="Объекты" value={objsCount} prefix={<EnvironmentOutlined/>}/>
          </Card>
        </Col>
      </Row>
      <Typography.Title level={4}>Последние исследования</Typography.Title>
      <Table
        loading={loading}
        dataSource={recentResearches}
        columns={columns}
        pagination={false}
      />
    </div>
  )
}

export default AdminIndexPage
